// extracted by mini-css-extract-plugin
module.exports = {"mainGrid":"mainBody_mainGrid__2XFCm","mainWrapper":"mainBody_mainWrapper__22w3n","splittext":"mainBody_splittext__3oLSY","linkarrow":"mainBody_linkarrow__1N5kv"};